import { Clock3, ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { ExtendedLearningCourse } from "../types/learning-presentation.js";

export function ExtendedLearningLinks({ courses }: { courses: readonly ExtendedLearningCourse[] }) {
  const { t } = useTranslation();
  if (!courses.length) return null;
  return (
    <section className="rounded-xl border border-border/70 bg-muted/35 p-4 sm:p-5">
      <h4 className="font-medium">{t("passportVig.lesson.extendedLearning.title")}</h4>
      <p className="mt-1 text-sm text-muted-foreground">{t("passportVig.lesson.extendedLearning.intro")}</p>
      <div className="mt-3 space-y-2">
        {courses.map((course) => (
          <a
            className="flex items-center justify-between gap-4 rounded-lg border border-border bg-background p-3 text-sm transition-colors hover:border-primary/40 hover:text-link focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/25"
            data-control-id={`passport.learning.extended.${course.id}`}
            href={course.href}
            key={course.id}
            rel="noreferrer"
            target="_blank"
          >
            <span>
              <span className="block font-medium">{course.title}</span>
              <span className="mt-0.5 flex items-center gap-1.5 text-xs text-muted-foreground">
                {course.provider}
                <Clock3 aria-hidden="true" className="size-3" />
                {t("passportVig.lesson.extendedLearning.durationHours", {
                  count: course.durationMinutes / 60,
                })}
              </span>
            </span>
            <span className="flex shrink-0 items-center gap-1.5 font-medium">
              {t("passportVig.lesson.extendedLearning.open")}
              <ExternalLink aria-hidden="true" className="size-4" />
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}
